export const searchVolopsRoutePathByLocale = {
  en: '/en/volunteer',
  es: '/es/voluntariado',
  pt: '/pt/voluntariado',
} as const;

export const searchVolopsRoutePaths = Object.values(
  searchVolopsRoutePathByLocale,
);

export const searchVolopsRoutePathsWithoutLang = Array.from(
  new Set(searchVolopsRoutePaths.map((path) => path.substring(3))),
);
